import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Plus, Trash2, Edit, X } from "lucide-react";
import { toast } from "sonner";

const empty = { name: "", designation: "", message: "", image_url: "" };

export default function EndorsementsAdmin() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => api.get("/endorsements").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editId) await api.put(`/admin/endorsements/${editId}`, form);
      else await api.post("/admin/endorsements", form);
      toast.success("Saved"); setForm(empty); setEditId(null); load();
    } catch (err) { toast.error("Save failed"); }
  };
  const edit = (r) => { setForm(r); setEditId(r.id); };
  const remove = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/admin/endorsements/${id}`);
    toast.success("Deleted"); load();
  };

  return (
    <div data-testid="admin-endorsements" className="space-y-8">
      <header><div className="label-eyebrow mb-2">Manage</div>
        <h1 className="font-display text-4xl text-[hsl(var(--primary))]">Endorsements</h1></header>

      <form onSubmit={save} className="bg-white border border-[hsl(var(--border-c))] p-6 grid sm:grid-cols-2 gap-4">
        <div><Label>Name *</Label><Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="end-name" /></div>
        <div><Label>Designation</Label><Input value={form.designation} onChange={(e) => setForm({ ...form, designation: e.target.value })} /></div>
        <div className="sm:col-span-2"><Label>Image URL</Label><Input value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} placeholder="https://..." /></div>
        <div className="sm:col-span-2"><Label>Message *</Label><Textarea required rows={3} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="end-message" /></div>
        <div className="sm:col-span-2 flex gap-3">
          <Button type="submit" data-testid="end-save" className="bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary-hover))] rounded-none uppercase tracking-widest">
            {editId ? <Edit size={14} className="mr-2" /> : <Plus size={14} className="mr-2" />}
            {editId ? "Update" : "Add"}
          </Button>
          {editId && <Button type="button" variant="outline" onClick={() => { setForm(empty); setEditId(null); }} className="rounded-none"><X size={14} className="mr-2" />Cancel</Button>}
        </div>
      </form>

      <div className="grid md:grid-cols-2 gap-4">
        {list.map((r) => (
          <div key={r.id} className="bg-white border border-[hsl(var(--border-c))] p-5">
            <div className="flex justify-between items-start gap-3">
              <div>
                <div className="font-display text-xl text-[hsl(var(--primary))]">{r.name}</div>
                <div className="text-[10px] uppercase tracking-widest text-[hsl(var(--fg-muted))]">{r.designation}</div>
              </div>
              <div className="flex gap-2">
                <button onClick={() => edit(r)}><Edit size={14} /></button>
                <button onClick={() => remove(r.id)} className="text-[hsl(var(--accent))]"><Trash2 size={14} /></button>
              </div>
            </div>
            <p className="mt-3 text-sm">{r.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
